import { render, staticRenderFns } from "./PrintReportAdmin.vue?vue&type=template&id=764e0d20&scoped=true"
import script from "./PrintReportAdmin.vue?vue&type=script&lang=js"
export * from "./PrintReportAdmin.vue?vue&type=script&lang=js"
import style0 from "./PrintReportAdmin.vue?vue&type=style&index=0&id=764e0d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e0d20",
  null
  
)

export default component.exports